/**
 * Quick Add Modal
 * 
 * Features:
 * 1. Click "Add +" button to open product detail modal
 * 2. Get product page content via Ajax
 * 3. Display product variants, quantity, add button, etc
 * 4. Support all product page features (variant selection, quantity adjustment, etc)
 */

(function() {
  'use strict';
  
  window.QuickAddModal = {
    $modal: null,
    $overlay: null,
    currentProductHandle: null,
    
    /**
     * Initialize
     */
    init: function() {
      this.bindEvents();
      this.addStyles();
      console.log('[QuickAdd] Initialized (modal will be created on first open)');
    },
    
    /**
     * Ensure modal exists
     */
    ensureModalExists: function() {
      if (this.$overlay && this.$overlay.length) {
        return; // Already created
      }
      
      console.log('[QuickAdd] Creating modal');
      this.createModalHTML();
    },
    
    /**
     * Create modal HTML
     */
    createModalHTML: function() {
      const modalHTML = `
        <div class="quick-add-modal">
          <div class="quick-add-header">
            <button type="button" class="quick-add-close" aria-label="Close">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.1493e-05 14.7058L6.89339 7.81245L3.1493e-05 0.919097L0.919146 -1.7255e-05L7.8125 6.89334L14.7059 -1.7255e-05L15.625 0.919097L8.73161 7.81245L15.625 14.7058L14.7059 15.6249L7.8125 8.73157L0.919146 15.6249L3.1493e-05 14.7058Z" fill="#1D1D1D"/>
              </svg>
            </button>
            <h2 class="quick-add-title">Quick Add</h2>
          </div>
          <div class="quick-add-content">
            <div class="quick-add-loading">
              <div class="spinner"></div>
              <p>Loading...</p>
            </div>
          </div>
        </div>
      `;
      
      // Find preset overlay container
      this.$overlay = $('#quick-add-overlay');
      
      if (this.$overlay.length) {
        // Container exists, insert modal inside overlay
        this.$overlay.html(modalHTML);
        console.log('[QuickAdd] Modal added to preset overlay container ✅');
      } else {
        // Fallback: Container does not exist, create full structure and add to body
        const fullHTML = `
          <div id="quick-add-overlay" class="quick-add-overlay" style="display: none;">
            ${modalHTML}
          </div>
        `;
        $('body').append(fullHTML);
        this.$overlay = $('#quick-add-overlay');
        console.log('[QuickAdd] Complete modal structure added to body (fallback)⚠️');
      }
      
      this.$modal = $('.quick-add-modal');
      
      // CSS
      this.addStyles();
    },
    
    /**
     * Add CSS styles
     */
    addStyles: function() {
      if ($('#quick-add-styles').length) return;
      
      const styles = `
        <style id="quick-add-styles">
          /**/
          .quick-add-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            animation: fadeIn 0.2s ease-out;
          }
          
          /**/
          .quick-add-modal {
            background: white;
            border-radius: 8px;
            max-width: 900px;
            width: 100%;
            max-height: 90vh;
            overflow: hidden;
            position: relative;
            animation: slideUp 0.3s ease-out;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
            display: flex;
            flex-direction: column;
          }
          
          /* Header */
          .quick-add-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 25px;
            border-bottom: 1px solid #e5e5e5;
            flex-shrink: 0;
            flex-direction: row-reverse; /* ，close */
          }
          
          /* Quick Add */
          .quick-add-title {
            font-size: 20px;
            font-weight: 600;
            margin: 0;
            color: #333;
            flex: 1; /**/
          }
          
          /* Close button */
          .quick-add-close {
            background: transparent;
            border: none;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
            color: #666;
            flex-shrink: 0; /**/
            margin-left: 15px; /**/
          }
          
          .quick-add-close:hover {
            background: #f5f5f5;
            color: #333;
          }
          
          /**/
          .quick-add-content {
            padding: 20px;
            overflow-y: auto;
            flex: 1;
          }
          
          /**/
          .quick-add-loading {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 300px;
            gap: 15px;
          }
          
          .spinner {
            width: 40px;
            height: 40px;
            border: 3px solid #f3f3f3;
            border-top: 3px solid #333;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          
          /**/
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          /**/
          @media (max-width: 768px) {
            .quick-add-modal {
              max-width: 100%;
              max-height: 95vh;
              margin: 0;
              border-radius: 8px 8px 0 0;
            }
            
            .quick-add-overlay {
              align-items: flex-end;
              padding: 0;
            }
          }
          
          /* Quick Addinside */
          .quick-add-content .breadcrumb,
          .quick-add-content .product__reviews,
          .quick-add-content .product__description-full {
            display: none;
          }
          
          /**/
          .quick-add-content .product-form {
            display: block !important;
          }
        </style>
      `;
      
      $('head').append(styles);
    },
    
    /**
     * Bind events
     */
    bindEvents: function() {
      const self = this;
      
      // Close button
      $(document).on('click', '.quick-add-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        self.close();
      });
      
      // Click
      $(document).on('click', '.quick-add-overlay', function(e) {
        if ($(e.target).hasClass('quick-add-overlay')) {
          self.close();
        }
      });
      
      // ESCkey to close
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && self.$overlay.is(':visible')) {
          self.close();
        }
      });
    },
    
    /**/
    open: function(productHandle, productTitle) {
      console.log('[QuickAdd] Opening product:', productHandle);
      
      // Already created
      this.ensureModalExists();
      
      this.currentProductHandle = productHandle;
      
      // Add addbg class to .cart-bg
      $('.cart-bg').addClass('addbg');
      
      // Show modal and loading state
      this.$overlay.fadeIn(200);
      $('body').css('overflow', 'hidden');
      
      // Load product content
      this.loadProduct(productHandle, productTitle);
    },
    
    /**
     * Load product content
     */
    loadProduct: function(productHandle, productTitle) {
      const self = this;
      
      // Show loading state
      this.$modal.find('.quick-add-content').html(`
        <div class="quick-add-loading">
          <div class="spinner"></div>
          <p>Loading ${productTitle || 'product'}...</p>
        </div>
      `);
      
      // Get product page via Ajax
      $.ajax({
        url: `/products/${productHandle}`,
        type: 'GET',
        dataType: 'html',
        success: function(html) {
          self.renderProduct(html);
        },
        error: function(xhr, status, error) {
          console.error('[QuickAdd] :', error);
          self.$modal.find('.quick-add-content').html(`
            <div class="quick-add-error">
              <p>Failed to load product. Please try again.</p>
              <button onclick="window.QuickAddModal.close()">Close</button>
            </div>
          `);
        }
      });
    },
    
    /**/
    renderProduct: function(html) {
      const self = this;
      const $html = $('<div>').html(html);
      
      // 
      // 
      let productContent = '';
      
      // 
      const selectors = [
        '.product__main',
        '.product-single',
        '.product-template',
        '[data-section-type="product"]',
        '.product-info-section',
        'main .product'
      ];
      
      for (let selector of selectors) {
        const $content = $html.find(selector);
        if ($content.length) {
          productContent = $content.html();
          console.log('[QuickAdd] :', selector);
          break;
        }
      }
      
      // ，main
      if (!productContent) {
        productContent = $html.find('main').html() || $html.find('.main-content').html();
      }
      
      if (!productContent) {
        console.error('[QuickAdd] ');
        this.$modal.find('.quick-add-content').html(`
          <div class="quick-add-error">
            <p>Unable to load product content.</p>
          </div>
        `);
        return;
      }
      
      // 
      this.$modal.find('.quick-add-content').html(productContent);
      
      // Quantity（）
      this.injectQuantitySelector();
      
      // Initialize product features
      setTimeout(() => {
        self.initializeProductFeatures();
      }, 100);
    },
    
    /**
     * Inject quantity selector（）
     */
    injectQuantitySelector: function() {
      const $content = this.$modal.find('.quick-add-content');
      
      // Quantity selector already exists
      if ($content.find('.quantity-input, input[name="quantity"]').length > 0) {
        console.log('[QuickAdd] Quantity selector already exists');
        return;
      }
      
      console.log('[QuickAdd] Inject quantity selector');
      
      // QuantityHTML
      const quantityHTML = `
        <div class="product-quantity-box quick-add-quantity" style="margin: 15px 0;">
          <label style="display: block; margin-bottom: 8px; font-weight: 600; font-size: 14px;">
            Quantity
          </label>
          <div class="quantity-box" style="display: flex; align-items: center; gap: 10px;">
            <button type="button" class="quantity-minus" style="
              width: 36px;
              height: 36px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              font-size: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
            ">−</button>
            <input 
              type="number" 
              name="quantity" 
              value="1" 
              min="1" 
              class="quantity-input"
              style="
                width: 60px;
                height: 36px;
                text-align: center;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 14px;
              "
            />
            <button type="button" class="quantity-plus" style="
              width: 36px;
              height: 36px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              font-size: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
            ">+</button>
          </div>
        </div>
      `;
      
      // Priority: Insert after .product-block--price（form）
      const $priceBlock = $content.find('.product-block.product-block--price');
      
      if ($priceBlock.length) {
        $priceBlock.after(quantityHTML);
        console.log('[QuickAdd] Quantity selector inserted.product-block--priceafter');
        return;
      }
      
      // Second choice: Insert after product title
      const $productTitle = $content.find('h1, .product-title, .product__title, [class*="title"]').first();
      
      if ($productTitle.length) {
        $productTitle.after(quantityHTML);
        console.log('[QuickAdd] Quantity selector insertedafter');
        return;
      }
      
      // Fallback: Insert after price element
      const $price = $content.find('.product__price, .price, [class*="price"]').first();
      
      if ($price.length) {
        $price.after(quantityHTML);
        console.log('[QuickAdd] Quantity selector insertedafter');
        return;
      }
      
      // Last fallback: Insert before Add to Cart button
      const $addButton = $content.find('.button--add-to-cart, [name="add"], .product-form__cart-submit').first();
      
      if ($addButton.length) {
        $addButton.before(quantityHTML);
        console.log('[QuickAdd] Quantity selector insertedAddbefore');
        return;
      }
      
      // Cannot find: Insert at content beginning
      $content.prepend(quantityHTML);
      console.log('[QuickAdd] Quantity selector insertedbeginning');
    },
    
    /**
     * Initialize product features
     */
    initializeProductFeatures: function() {
      console.log('[QuickAdd] Initialize product features');
      
      // Re-initialize theme product features
      if (window.PXUTheme && window.PXUTheme.productPage) {
        try {
          window.PXUTheme.productPage.init();
        } catch (e) {
          console.warn('[QuickAdd] :', e);
        }
      }
      
      // Hijack Add to Cart button
      this.hijackAddToCartButton();
      
      // Initialize variant selection
      this.initializeVariantSelection();
      
      // Initialize quantity box
      this.initializeQuantityBox();
    },
    
    /**
     * Hijack Add to Cart button
     */
    hijackAddToCartButton: function() {
      const self = this;
      
      // Find Add to Cart button
      const $addButton = this.$modal.find('.button--add-to-cart, [name="add"], .product-form__cart-submit');
      
      if ($addButton.length) {
        // Remove original events
        $addButton.off('click.quickadd');
        
        // Add new event
        $addButton.on('click.quickadd', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const $btn = $(this);
          const $form = $btn.closest('form');
          
          // Get variant ID (required)
          let variantId = null;
          
          // Try to get from form
          const formData = $form.serializeArray();
          formData.forEach(item => {
            if (item.name === 'id') {
              variantId = item.value;
            }
          });
          
          // If not in form, find elsewhere
          if (!variantId) {
            const $variantInput = self.$modal.find('input[name="id"], select[name="id"]');
            variantId = $variantInput.val();
          }
          
          // Get quantity (search entire modal, not limited to form)
          let quantity = 1;
          const $quantityInput = self.$modal.find('input[name="quantity"], .quantity-input');
          if ($quantityInput.length) {
            quantity = parseInt($quantityInput.val()) || 1;
          }
          
          // Build data
          const data = {
            id: variantId,
            quantity: quantity
          };
          
          // Add other form data (like properties)
          formData.forEach(item => {
            if (item.name !== 'id' && item.name !== 'quantity') {
              data[item.name] = item.value;
            }
          });
          
          console.log('[QuickAdd] Variant ID:', variantId);
          console.log('[QuickAdd] Quantity:', quantity);
          console.log('[QuickAdd] Complete data:', data);
          
          if (!variantId) {
            console.error('[QuickAdd] Missing variant ID');
            alert('Please select a variant');
            $btn.prop('disabled', false).text('Add to Bag');
            return;
          }
          
          // Disable button
          $btn.prop('disabled', true).text('Adding...');
          
          // Send Ajax request
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(item) {
              console.log('[QuickAdd] ========== ADD TO CART SUCCESS ==========');
              console.log('[QuickAdd] Response:', item);
              console.log('[QuickAdd] Product ID:', item.product_id);
              console.log('[QuickAdd] Quantity added:', item.quantity);
              console.log('[QuickAdd] Item:', item);
              
              // Update button state
              $btn.text('Added!').addClass('added');
              console.log('[QuickAdd] Button updated to "Added!"');
              
              // Force update cart view multiple times to ensure product shows
              if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
                console.log('[QuickAdd] Starting cart updates...');
                
                // Immediate update
                console.log('[QuickAdd] Cart update #1 (immediate)');
                window.PXUTheme.jsAjaxCart.updateView();
                
                // Update again after 500ms to catch partial stock additions
                setTimeout(function() {
                  console.log('[QuickAdd] Cart update #2 (500ms)');
                  window.PXUTheme.jsAjaxCart.updateView();
                }, 500);
                
                // Final update after 1000ms
                setTimeout(function() {
                  console.log('[QuickAdd] Cart update #3 (1000ms - final)');
                  window.PXUTheme.jsAjaxCart.updateView();
                }, 1000);
              } else {
                console.warn('[QuickAdd] PXUTheme.jsAjaxCart not available!');
              }
              
              // Trigger Complete The Fit update after cart is updated
              setTimeout(function() {
                console.log('[QuickAdd] Triggering cart:updated event');
                $(document).trigger('cart:updated');
                
                // Also call directly if available
                if (window.updateCompleteTheFit) {
                  console.log('[QuickAdd] Calling updateCompleteTheFit directly');
                  window.updateCompleteTheFit();
                }
              }, 1200);
              
              // Close modal after 2 seconds (give more time for cart to update)
              console.log('[QuickAdd] Will close modal in 2 seconds');
              setTimeout(function() {
                console.log('[QuickAdd] Closing modal now');
                self.close();
              }, 2000);
            },
            error: function(xhr) {
              console.error('[QuickAdd] Add failed with status:', xhr.status);
              console.log('[QuickAdd] Response:', xhr.responseText);
              
              // Check if it's a stock limitation error (422)
              // Shopify returns 422 when quantity exceeds stock, but may still add available quantity
              if (xhr.status === 422) {
                console.log('[QuickAdd] 422 error - likely stock limitation');
                
                try {
                  const response = JSON.parse(xhr.responseText);
                  console.log('[QuickAdd] Error response:', response);
                  
                  // Check if error message indicates partial add
                  if (response.description && response.description.includes('items were added')) {
                    console.log('[QuickAdd] Partial add detected - treating as success');
                    
                    // Show stock limitation alert to user
                    alert(response.description);
                    
                    // Treat this as a success - update cart
                    $btn.text('Added!').addClass('added');
                    
                    // Force update cart view multiple times
                    if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
                      console.log('[QuickAdd] Starting cart updates after 422...');
                      
                      // Immediate update
                      console.log('[QuickAdd] Cart update #1 (immediate)');
                      window.PXUTheme.jsAjaxCart.updateView();
                      
                      // Update again after 500ms
                      setTimeout(function() {
                        console.log('[QuickAdd] Cart update #2 (500ms)');
                        window.PXUTheme.jsAjaxCart.updateView();
                      }, 500);
                      
                      // Final update after 1000ms
                      setTimeout(function() {
                        console.log('[QuickAdd] Cart update #3 (1000ms - final)');
                        window.PXUTheme.jsAjaxCart.updateView();
                      }, 1000);
                    }
                    
                    // Trigger Complete The Fit update
                    setTimeout(function() {
                      console.log('[QuickAdd] Triggering cart:updated event');
                      $(document).trigger('cart:updated');
                      
                      if (window.updateCompleteTheFit) {
                        console.log('[QuickAdd] Calling updateCompleteTheFit directly');
                        window.updateCompleteTheFit();
                      }
                    }, 1200);
                    
                    // Close modal after 2 seconds
                    console.log('[QuickAdd] Will close modal in 2 seconds');
                    setTimeout(function() {
                      console.log('[QuickAdd] Closing modal now');
                      self.close();
                    }, 2000);
                    
                    // Don't show error alert again for partial adds (already shown above)
                    return;
                  }
                } catch (e) {
                  console.error('[QuickAdd] Error parsing response:', e);
                }
              }
              
              // For other errors, restore button and show error
              $btn.prop('disabled', false).text('Add to Bag');
              
              // Show error
              try {
                const response = JSON.parse(xhr.responseText);
                alert(response.description || 'Failed to add to cart');
              } catch (e) {
                alert('Failed to add to cart');
              }
            }
          });
        });
      }
    },
    
    /**
     * Initialize variant selection
     */
    initializeVariantSelection: function() {
      const self = this;
      
      // 
      this.$modal.find('input[name="id"], select[name="id"]').on('change', function() {
        const variantId = $(this).val();
        console.log('[QuickAdd] Variant selected:', variantId);
        
        // 、
        // 
      });
      
      // 、
      this.$modal.find('[data-option-select]').on('change', function() {
        console.log('[QuickAdd] Option changed');
      });
    },
    
    /**
     * Initialize quantity box
     */
    initializeQuantityBox: function() {
      const self = this;
      
      // Re-bind quantity buttons
      this.$modal.find('.quantity-plus, .quantity-minus').off('click').on('click', function(e) {
        e.preventDefault();
        const $input = $(this).siblings('.quantity-input');
        let value = parseInt($input.val()) || 1;
        
        if ($(this).hasClass('quantity-plus')) {
          value++;
        } else if ($(this).hasClass('quantity-minus') && value > 1) {
          value--;
        }
        
        $input.val(value).trigger('change');
      });
    },
    
    /**
     * Close modal
     */
    close: function() {
      console.log('[QuickAdd] Close modal');
      
      // Remove addbg class from .cart-bg
      $('.cart-bg').removeClass('addbg');
      
      this.$overlay.fadeOut(200);
      $('body').css('overflow', '');
      
      // Clear content
      setTimeout(() => {
        this.$modal.find('.quick-add-content').html(`
          <div class="quick-add-loading">
            <div class="spinner"></div>
            <p>Loading...</p>
          </div>
        `);
      }, 300);
    }
  };
  
  // DOMafter
  $(document).ready(function() {
    window.QuickAddModal.init();
  });
  
})();